import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

// API related
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import { endpointService } from "#src/services/endpoint";

// Components
import { Modal } from "@lockerpm/design";
import { ButtonV2 } from "#src/commonV2/Button";
import { createToast } from "#src/common/system/toasts";

type Props = {
  isOpen: boolean;
  workspaceId: string;
  passportId: string;
  closeModal: () => void;
  onSuccess: (id: string) => void;
};

const DeletePassportModal = (props: Props) => {
  const { isOpen, workspaceId, passportId, onSuccess, closeModal } = props;

  const { t } = useTranslation("endpoint", { keyPrefix: "passports" });

  // --------------- DATA ---------------

  const [isLoading, setIsLoading] = useState(false);

  // --------------- COMPUTED ---------------

  // --------------- METHODS ---------------

  // Delete deparment
  const deletePassport = useCallback(async () => {
    if (!workspaceId || !passportId) {
      return;
    }

    setIsLoading(true);
    try {
      await endpointService.deletePassport(workspaceId, passportId);
      createToast({
        type: "success",
        message: t("modal.delete.notification.deleteSuccess"),
      });
      closeModal();
      onSuccess(passportId);
    } catch (error) {
      apiErrorHandler(error, {
        toastMessage: t("modal.delete.notification.deleteFail"),
      });
    }

    setIsLoading(false);
  }, [workspaceId, passportId, closeModal, onSuccess, t]);

  // --------------- EFFECTS ---------------

  // --------------- RENDER ---------------

  return (
    <Modal
      title={<p>{t("modal.delete.title")}</p>}
      open={isOpen}
      footer={null}
      maskClosable={false}
      onCancel={closeModal}
      className="v2 max-w-[600px]"
      centered
      width="90%"
    >
      <div className="v2">
        {/* Desc */}
        <p className="text-md text-gray-v2-600 mb-3">
          {t("modal.delete.desc1")}
        </p>
        <p className="text-md text-gray-v2-600">{t("modal.delete.desc2")}</p>
        {/* Desc end */}

        {/* Footer */}
        <div className="flex gap-2 justify-end mt-8">
          <ButtonV2
            variant="secondary"
            size="md"
            color="gray"
            onClick={closeModal}
          >
            <p>{t("modal.delete.button.cancel")}</p>
          </ButtonV2>

          <ButtonV2
            variant="primary"
            size="md"
            color="error"
            pending={isLoading}
            onClick={deletePassport}
          >
            <p>{t("modal.delete.button.delete")}</p>
          </ButtonV2>
        </div>
        {/* Footer end */}
      </div>
    </Modal>
  );
};

export default DeletePassportModal;
